import React from "react";
import { Outlet } from "react-router-dom";
import Topbar from "../../pages/WebsitePages/Components/Common/TopBar";
import Navbar from "../../pages/WebsitePages/Components/Common/Navbar";

const UserProfileLayout = () => {
  return (
    <>
    <div className="user-dashboard">
      <Navbar/>
      <section class="main_content dashboard_part large_header_bg " id="main-layout-section">
        <Topbar />
        <div className="main_content_iner overly_inner " id="main-inner-layout-section">
          <Outlet/>
        </div>  
      </section>
      </div>
    </>
  );
};

export default UserProfileLayout;
